import React from 'react';
import {Button, Col, Image, Modal, Row} from "react-bootstrap";
import './style.css';

export const SubscriptionModal = ({show, hide}) => {
    return (
        <Modal show={show} onHide={hide} bsSize="large">
            <Modal.Body style={{height: 525, padding: 30 }}>
                <h2 style={{ color: '#333333', fontFamily: 'Montserrat',fontSize: 24, fontWeight: 800}}>UPGRADE TO DESIGNS.AI PRO </h2>
                <p style={{ color: '#333333', fontFamily: 'Montserrat',fontSize: 14, fontWeight: 500 }} >	
                    <Row>
                        <Col xs={6}>
                        	<br />
                        	For entrepreneurs and small teams that need advanced editing and professional templates
                        	<br/>
                        	<ul style={{ marginTop: 25, marginBottom: 25, listStyle: 'none' }} className="subscription_list">
                        		<li className="subscription_list_item" style={{ marginTop: 10, marginBottom: 15 }}>Access to all templates and elements in Designs.ai library</li>
                        		<li className="subscription_list_item" style={{ marginTop: 10, marginBottom: 15 }}>Monthly quota of 40 premium images and 10 premium videos from 123RF and Getty Images</li>
                        		<li className="subscription_list_item" style={{ marginTop: 10, marginBottom: 15 }}>A.I powered banner resizing and design color swap</li>
                        		<li className="subscription_list_item" style={{ marginTop: 10, marginBottom: 15 }}>Upgraded cloud storage of upto 5 GB</li>
                        	</ul>
                        	<p style={{ marginTop: 10, marginBottom: 30 }}>Plus many more stunning features to use throughout the Designs.ai suite</p>
                        </Col>
                        <Col xs={6}>
                            <Image style={{ width: '100%', paddingTop: 50 }} src={global.config.server_path + 'uploads/try_pro.png'}/>
                        </Col>
                        
                    </Row>
                </p>
                {/* <Button></Button> */}
                <Button className="btn-orange" onClick={()=> window.open(global.config.website_url, "_blank")}>Upgrade today</Button>
            </Modal.Body>
        </Modal>
        );
};